import React, { useState, useEffect,useRef } from "react";
import Map, { Marker, Popup } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
// import { places } from "../../../../mock/data";
import "./styles.css";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import isMock from "../../../../config";
import DashboardNavbar from "../../../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../../../examples/LayoutContainers/DashboardLayout";
import {useMaterialUIController} from "../../../../context";
import MDBox from "../../../../components/MDBox";
import mapboxgl from "mapbox-gl";

function MapView() {
    const [coordinates, setCoordinates] = useState([]);
    const [randomPrices, setRandomPrices] = useState({});
    const [randomFreeNumbers, setRandomFreeNumbers] = useState({});
    const [showFreePlaces, setShowFreePlaces] = useState(true);
    const [hoveredMarker, setHoveredMarker] = useState(null);
    const [places, setPlaces] = useState([]);
    const [mapUrl, setMapUrl] = useState('mapbox://styles/mapbox/dark-v11');
    const [streetMode, setStreetMode] = useState(true);
    const dashboardMapRef = useRef(null);
    const dashboardMapInstanceRef = useRef(null);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    async function fetchFreePlacesForPlace(placeId) {
        try {
            // 1) Get carsPresent
            const usersResponse = await fetch(
                `https://portal.pal-es.com/api1/place/${placeId==='3d7977db-6332-4edd-9291-d2eca8ca6505' ? 'aed5dcca-067a-4d32-987d-5bd8a0036ce8' : placeId}/users?skip=999999999999999&limit=10&filter=`,
                {
                    headers: {
                        "X-Access-Token":
                            "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJleHAiOjE5MjI3NzY2NzI3ODQsImlkIjoiYXBpQHRlY2hub3NvLmNvLmlsIiwiaml0IjoiOGYzMGQ1ODItNDdhMC00YmE1LThkMTYtZmJjNWI5ZTBhMzg3IiwiaiI6MSwiYXBpIjp0cnVlfQ.jK422OtV7Bhl6ULp8xzKxTXo0SJJXudWMvRHfgptNOcKauCd87lK9qHdghJ8FqfedyohjK_RyuCtTIKRaZxXFw"
                    }
                }
            );
            const usersData = await usersResponse.json();
            const carsPresent = usersData.users.carsPresent || 0;

            // 2) Get allocation and overflow
            const allocResponse = await fetch(
                `https://portal.pal-es.com/api1/place/${placeId==='3d7977db-6332-4edd-9291-d2eca8ca6505' ? 'aed5dcca-067a-4d32-987d-5bd8a0036ce8' : placeId}`,
                {
                    headers: {
                        "X-Access-Token":
                            "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJleHAiOjE5MjI3NzY2NzI3ODQsImlkIjoiYXBpQHRlY2hub3NvLmNvLmlsIiwiaml0IjoiOGYzMGQ1ODItNDdhMC00YmE1LThkMTYtZmJjNWI5ZTBhMzg3IiwiaiI6MSwiYXBpIjp0cnVlfQ.jK422OtV7Bhl6ULp8xzKxTXo0SJJXudWMvRHfgptNOcKauCd87lK9qHdghJ8FqfedyohjK_RyuCtTIKRaZxXFw"
                    }
                }
            );
            const allocData = await allocResponse.json();
            const allocation = allocData.place.settings.parkingAllocation || 0;
            const overflowCount = allocData.place.settings.overflowCount || 0;

            // Return final free places
            return allocation + overflowCount - carsPresent;
        } catch (error) {
            console.error("Error fetching data for placeId:", placeId, error);
            return null;
        }
    }

    useEffect(() => {
        if (!dashboardMapRef.current) return;
        if (dashboardMapInstanceRef.current) return;

        const map = new mapboxgl.Map({
            container: dashboardMapRef.current,
            style: "mapbox://styles/mapbox/streets-v11",
            center: [34.7818, 32.0853], // Tel Aviv-ish default
            zoom: 6,
        });

        dashboardMapInstanceRef.current = map;

        map.addControl(new mapboxgl.NavigationControl(), "top-right");

        map.on("load", async () => {
            const res = await fetch("https://blue-parking-invite.bluept.dev/api/pal-places/leaf-locations");
            const json = await res.json();
            const geojson = json?.geojson || { type: "FeatureCollection", features: [] };

            map.addSource("leafPlaces", {
                type: "geojson",
                data: geojson,
                cluster: true,
                clusterMaxZoom: 14,
                clusterRadius: 50,
            });

            // clusters (circles)
            map.addLayer({
                id: "clusters",
                type: "circle",
                source: "leafPlaces",
                filter: ["has", "point_count"],
                paint: {
                    // Mapbox default-ish cluster styling (no manual colors needed)
                    "circle-radius": ["step", ["get", "point_count"], 16, 25, 22, 100, 28],
                    "circle-stroke-width": 2,
                    "circle-stroke-color": "#fff",
                    "circle-color": "#1976D2",   // light blue
                },
            });

            // cluster count label
            map.addLayer({
                id: "cluster-count",
                type: "symbol",
                source: "leafPlaces",
                filter: ["has", "point_count"],
                layout: {
                    "text-field": "{point_count_abbreviated}",
                    "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                    "text-size": 12,
                },
                paint: {
                    "text-color": "white",
                },
            });

            // unclustered points
            map.addLayer({
                id: "unclustered-point",
                type: "circle",
                source: "leafPlaces",
                filter: ["!", ["has", "point_count"]],
                paint: {
                    "circle-radius": 6,
                    "circle-stroke-width": 2,
                    "circle-stroke-color": "#fff",
                    "circle-color": "#1976D2",   // light blue
                },
            });

            // click cluster -> zoom in
            map.on("click", "clusters", (e) => {
                const features = map.queryRenderedFeatures(e.point, { layers: ["clusters"] });
                const clusterId = features?.[0]?.properties?.cluster_id;
                if (clusterId == null) return;

                map.getSource("leafPlaces").getClusterExpansionZoom(clusterId, (err, zoom) => {
                    if (err) return;
                    map.easeTo({ center: features[0].geometry.coordinates, zoom });
                });
            });

            // click a single point -> popup
            map.on("click", "unclustered-point", (e) => {
                const f = e.features?.[0];
                if (!f) return;

                const coords = f.geometry.coordinates.slice();
                const { name, address_name } = f.properties || {};

                new mapboxgl.Popup()
                    .setLngLat(coords)
                    .setHTML(
                        `<div style="font-size:13px;">
             <div style="font-weight:700;">${name || ""}</div>
             <div>${address_name || ""}</div>
           </div>`
                    )
                    .addTo(map);
            });

            map.on("mouseenter", "clusters", () => (map.getCanvas().style.cursor = "pointer"));
            map.on("mouseleave", "clusters", () => (map.getCanvas().style.cursor = ""));
            map.on("mouseenter", "unclustered-point", () => (map.getCanvas().style.cursor = "pointer"));
            map.on("mouseleave", "unclustered-point", () => (map.getCanvas().style.cursor = ""));
        });

        return () => {
            map.remove();
            dashboardMapInstanceRef.current = null;
        };
    }, []);


    useEffect(() => {
        // This function loops over all our places/coordinates
        // and fetches the actual free places from the server.
        const updateFreeNumbers = async () => {
            const freeNumbers = {};

            // Make sure each "place" has a unique placeId in your database
            // so you know which place to fetch from the server
            for (const place of coordinates) {
                // Suppose place has a property place.placeId
                // If your data doesn’t have placeId yet, you’ll need to store it somewhere
                const free = await fetchFreePlacesForPlace(place.placeId);
                freeNumbers[place.id] = free === null ? 0 : free;
            }

            setRandomFreeNumbers(freeNumbers);
        };

        // call once on mount or whenever `coordinates` changes
        updateFreeNumbers();

        // set up a timer to refresh every 60 seconds
        const interval = setInterval(() => {
            updateFreeNumbers();
        }, 60000);

        return () => clearInterval(interval);
    }, [coordinates]);


    async function fetchData() {
        try {
            const usersResponse = await fetch(
                `https://portal.pal-es.com/api1/place/53e2fbcc-e3dc-4a81-b3da-3eb390353122/users?skip=999999999999999&limit=10&filter=`,
                {
                    headers: {
                        'X-Access-Token': "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJleHAiOjE5MjI3NzY2NzI3ODQsImlkIjoiYXBpQHRlY2hub3NvLmNvLmlsIiwiaml0IjoiOGYzMGQ1ODItNDdhMC00YmE1LThkMTYtZmJjNWI5ZTBhMzg3IiwiaiI6MSwiYXBpIjp0cnVlfQ.jK422OtV7Bhl6ULp8xzKxTXo0SJJXudWMvRHfgptNOcKauCd87lK9qHdghJ8FqfedyohjK_RyuCtTIKRaZxXFw"
                    }
                }
            );
            const usersData = await usersResponse.json();
            // For a generic flow, we assume a property like "carsPresent" holds the count.
            const carsPresent = usersData.users.carsPresent;

            // Fetch allocation
            const allocResponse = await fetch(
                `https://portal.pal-es.com/api1/place/53e2fbcc-e3dc-4a81-b3da-3eb390353122`,
                {
                    headers: {
                        'X-Access-Token': "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJleHAiOjE5MjI3NzY2NzI3ODQsImlkIjoiYXBpQHRlY2hub3NvLmNvLmlsIiwiaml0IjoiOGYzMGQ1ODItNDdhMC00YmE1LThkMTYtZmJjNWI5ZTBhMzg3IiwiaiI6MSwiYXBpIjp0cnVlfQ.jK422OtV7Bhl6ULp8xzKxTXo0SJJXudWMvRHfgptNOcKauCd87lK9qHdghJ8FqfedyohjK_RyuCtTIKRaZxXFw"
                    }
                }
            );
            let allocation;
            const allocData = await allocResponse.json();
            allocation = allocData.place.settings.parkingAllocation;
            const overFlowCount = allocData.place.settings.overflowCount;
            return allocation-carsPresent;
        } catch (error) {
            console.error(`Error fetching data for placeId ${this.placeId}:`, error.message);
            return null;
        }
    }



    // useEffect(() => {
    //     (async function fetchPlaces  ()  {
    //         const response = await fetch(
    //             "http://localhost:3001/places?parentId=null"
    //         );
    //         if (!response.ok) {
    //             throw new Error("Failed to fetch places");
    //         }
    //         const data = await response.json();
    //         setPlaces(isMock ? data : data.places.data);
    //         // console.log(data.places.data);
    //     })();
    // },[]);

    // Fetch coordinates from API
    useEffect(() => {
        console.log('places', places);
        const fetchCoordinates = async () => {
            const accessToken =
                "pk.eyJ1IjoibGVvbnRvbWVyIiwiYSI6ImNtNTVjeTdwcTJ3em4yanNkeHg3eDNhaW0ifQ.3Tg0RL9HhK4yQRzVpMMB1Q"; // Replace with your token
            const coords = await Promise.all(
                places.map(async (place, index) => {
                    try {
                        const response = await fetch(
                            `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
                                place.address
                            )}.json?access_token=${accessToken}`
                        );
                        const data = await response.json();
                        if (data.features && data.features.length > 0) {
                            const [longitude, latitude] = data.features[0].center;
                            return { ...place, id: index, latitude, longitude };
                        }
                        console.error(`Geocoding failed: ${place.address}`);
                        return null;
                    } catch (error) {
                        console.error(error);
                        return null;
                    }
                })
            );
            setCoordinates(coords.filter(Boolean));
        };

        fetchCoordinates();
    }, [places]);

    // Generate static random prices and initial free numbers
    useEffect(() => {
        const generateInitialValues = () => {
            const prices = {};
            coordinates.forEach((place) => {
                prices[place.id] = Math.floor(Math.random() * 100) + 1; // Static price
            });
            setRandomPrices(prices);
        };

        generateInitialValues();
    }, [coordinates]);


    return (
        <div style={{width: "100%", paddingTop: "-112px"}}>
            {/* Switch positioned above the map */}
            <div style={{display: "flex", justifyContent: "space-between", marginBottom: "10px"}}>
                {/*<FormControlLabel*/}
                {/*    control={*/}
                {/*        <Switch*/}
                {/*            checked={showFreePlaces}*/}
                {/*            onChange={() => setShowFreePlaces(!showFreePlaces)}*/}
                {/*        />*/}
                {/*    }*/}
                {/*    label={showFreePlaces ? "By Free Places" : "By Prices"}*/}
                {/*/>*/}
                {/*<FormControlLabel*/}
                {/*    control={*/}
                {/*        <Switch*/}
                {/*            checked={!streetMode}*/}
                {/*            onChange={() => setStreetMode(!streetMode)}*/}
                {/*        />*/}
                {/*    }*/}
                {/*    label={!streetMode ? "Show Street View" : "Show Map View"}*/}
                {/*/>*/}
            </div>

            <MDBox
                sx={{
                    height: 720,
                    borderRadius: "16px",
                    overflow: "hidden",
                    border: darkMode ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.08)",
                    mb: 3,
                }}
            >
                <div ref={dashboardMapRef} style={{ width: "100%", height: "100%" }} />
            </MDBox>
            {/*<div style={{ height: "calc(95vh - 330px)"}}>*/}
            {/*    <Map*/}
            {/*        mapboxAccessToken="pk.eyJ1IjoibGVvbnRvbWVyIiwiYSI6ImNtNTVjeTdwcTJ3em4yanNkeHg3eDNhaW0ifQ.3Tg0RL9HhK4yQRzVpMMB1Q"*/}
            {/*        initialViewState={{*/}
            {/*            latitude: 31.8781,*/}
            {/*            longitude: 34.7398,*/}
            {/*            zoom: 6.2,*/}
            {/*        }}*/}
            {/*        style={{width: "100%", height: "100%"}}*/}
            {/*        attributionControl={false}*/}
            {/*        mapStyle={streetMode ? "mapbox://styles/mapbox/satellite-streets-v11" : darkMode ? 'mapbox://styles/mapbox/dark-v11' : 'mapbox://styles/mapbox/light-v11'}*/}
            {/*    >*/}
            {/*        {coordinates.map((place) => {*/}
            {/*            const displayValue = showFreePlaces*/}
            {/*                ? randomFreeNumbers[place.id]*/}
            {/*                : `₪${randomPrices[place.id]}`;*/}

            {/*            return (*/}
            {/*                <React.Fragment key={place.id}>*/}
            {/*                    <Marker latitude={place.latitude} longitude={place.longitude}>*/}
            {/*                        <div*/}
            {/*                            onMouseEnter={() => setHoveredMarker(place)}*/}
            {/*                            onMouseLeave={() => setHoveredMarker(null)}*/}
            {/*                            style={{cursor: "pointer"}}*/}
            {/*                        >*/}
            {/*                            <div*/}
            {/*                                className={place.placeId === '3d7977db-6332-4edd-9291-d2eca8ca6505' ? "marker-shape special" : "marker-shape"}>*/}
            {/*                                <div className="marker-inner">*/}
            {/*                                    {showFreePlaces*/}
            {/*                                        ? randomFreeNumbers[place.id] ?? 0*/}
            {/*                                        : `₪${randomPrices[place.id] ?? 0}`*/}
            {/*                                    }*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </Marker>*/}

            {/*                    {hoveredMarker && hoveredMarker.id === place.id && (*/}
            {/*                        <Popup*/}
            {/*                            latitude={place.latitude}*/}
            {/*                            longitude={place.longitude}*/}
            {/*                            closeButton={false}*/}
            {/*                            offsetTop={-40}*/}
            {/*                            anchor="bottom"*/}
            {/*                        >*/}
            {/*                            <div style={{fontSize: "12px", fontWeight: "bold"}}>*/}
            {/*                                {place.address}*/}
            {/*                            </div>*/}
            {/*                        </Popup>*/}
            {/*                    )}*/}
            {/*                </React.Fragment>*/}
            {/*            );*/}
            {/*        })}*/}
            {/*    </Map>*/}
            {/*</div>*/}
        </div>
    );
}

export default MapView;
